var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.149 12.931l-2.746-.686-.233-.935a4.937 4.937 0 001.386-2.75 1.08 1.08 0 00.777-.902l.18-1.434a1.073 1.073 0 00-.686-1.136l.065-1.35.268-.268c.404-.429.738-1.166.04-2.233C12.661.417 11.747 0 10.484 0c-.499 0-1.647 0-2.716.718-3.053.064-3.47 1.482-3.47 2.865 0 .322.08 1.046.13 1.484a1.077 1.077 0 00-.742 1.158l.18 1.434c.059.466.413.834.861.922a4.97 4.97 0 001.319 2.667l-.25.998-2.745.687A4.02 4.02 0 000 16.841a.36.36 0 00.358.358H16.84a.36.36 0 00.359-.359 4.024 4.024 0 00-3.051-3.909",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.87115c3ea572bbecb98aafddb18b89e1.svg";
export { ForwardRef as ReactComponent };